import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { TokenService } from './services/token/token.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `<router-outlet></router-outlet>`,
  styles: [],
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private tokenService: TokenService) {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit(): void {
    window.onbeforeunload = () => window.scrollTo(0, 0);
    this.tokenService.fetchToken().subscribe({
      next: () => {},
      error: (err) => console.error('Error fetching token', err),
    });
  }
}
